<template>
  <div class="auth-login-page">
    <aside class="left-pane">
      <div class="left-logo">
        <img :src="logoSrc" alt="Orderly2" />
      </div>

      <div class="left-copy">
        <h1>Gestiona tus negocios y finanzas en un solo lugar</h1>
        <p>
          La plataforma administrativa diseñada para empresas creativas y de servicios. 
          Controla tus finanzas, clientes y operaciones facilmente.
        </p>
      </div>
    </aside>

    <section class="right-pane">
      <div class="login-card">
        <h2>Iniciar sesión</h2>
        <p class="subtitle">Bienvenido de nuevo. Por favor, ingresa tus datos.</p>

        <form class="theme-form" @submit.prevent="login">
          <div class="field-group">
            <label>Email</label>
            <div class="input-wrap" :class="{ 'has-error': v$.form.email.$error }">
              <i class="fa fa-envelope" aria-hidden="true"></i>
              <input
                type="email"
                placeholder="ejemplo@empresa.com"
                v-model="form.email"
                @input="normalizeEmail"
                @blur="v$.form.email.$touch()"
              />
            </div>
            <div class="invalid-feedback d-block" v-if="v$.form.email.$error">
              {{ v$.form.email.$errors[0].$message }}
            </div>
          </div>

          <div class="field-group">
            <div class="label-row">
              <label>Contraseña</label>
              <router-link class="recover-link" :to="{ name: 'recoverPassword' }">
                ¿Olvidaste tu contraseña?
              </router-link>
            </div>

            <div class="input-wrap" :class="{ 'has-error': v$.form.password.$error }">
              <i class="fa fa-lock" aria-hidden="true"></i>
              <input
                :type="showPassword ? 'text' : 'password'"
                placeholder="••••••••"
                v-model="form.password"
                @blur="v$.form.password.$touch()"
              />
              <button type="button" class="eye-btn" @click="showPassword = !showPassword">
                <i class="fa" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
              </button>
            </div>

            <div class="invalid-feedback d-block" v-if="v$.form.password.$error">
              {{ v$.form.password.$errors[0].$message }}
            </div>
          </div>

          <label class="remember-row" for="remember-session">
            <input id="remember-session" type="checkbox" v-model="rememberSession" />
            <span>Recordar sesión</span>
          </label>

          <button class="submit-btn" type="submit">
            Iniciar sesión
          </button>
        </form>

        <div class="bottom-line"></div>
        <p class="sales-copy">
          ¿No tienes una cuenta?
          <a href="mailto:ventas@orderly.site">Contacta con ventas</a>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import logoSrc from '@/assets/images/logo/logo.png';
import ws from '@/services/login';
import { normalizeEmail } from '@/mixins/normalizers';
import { useVuelidate } from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'
import moment from 'moment';
import { saveCapabilitiesSnapshot } from '@/utils/capabilities';

export default {
  name: 'login',

  data() {
    return {
      logoSrc,
      showPassword: false,
      rememberSession: false,
      form: {
        email: '',
        password: ''
      }
    }
  },

  validations() {
    return {
      form: {
        email: {
          required: helpers.withMessage('Ingresa tu correo electrónico', required),
          email: helpers.withMessage('Ingresa un correo válido', email)
        },
        password: {
          required: helpers.withMessage('Ingresa tu contraseña', required)
        }
      }
    }
  },

  setup() {
    return { v$: useVuelidate() }
  },

  methods: {
    normalizeEmail() {
      this.form.email = normalizeEmail(this.form.email)
    },
    async login() {
      this.normalizeEmail()

      this.v$.$touch()
      if (this.v$.$invalid) return

      this.$loading.show()

      try {
        const email = normalizeEmail(this.form.email)
        const response = await ws.login(email, this.form.password)

        if (response.type !== "success") {
          this.$toast.error(response.message)
          return
        }

        const data = response.data
        const token = data.token
        const user  = data.user

        localStorage.setItem('access_token', token)
        localStorage.setItem('user', JSON.stringify(user))

        await this.hydrateCapabilitiesOnLogin()
        this.$router.push({ name: 'home' })

      } catch (e) {
        this.$toast.error('Error al iniciar sesión')
      } finally {
        this.$loading.hide()
      }
    },
    async hydrateCapabilitiesOnLogin() {
      try {
        const response = await ws.validate({ skipLoading: true })
        const payload = response?.data || {}
        const capabilities = payload?.capabilities || {}

        saveCapabilitiesSnapshot({
          user_id: payload?.user_id ?? null,
          account_id: payload?.account_id ?? null,
          capabilities,
        })
      } catch (error) {
        saveCapabilitiesSnapshot({ capabilities: {} })
      }
    }
  }
}

</script>
